import { useState } from 'react'
import type { JSX } from 'react'
import { NavLink } from 'react-router-dom'

import {
  Button,
  ChevronDownIcon,
  ChevronUpIcon,
  Flex,
  FolderIcon,
  FolderOpenIcon,
  IconButton,
  Popover,
  Text,
} from '@buffer-mono/popcorn'

import { FeedItemIcon } from '~publish/pages/Create/Feed/components/FeedIcon/FeedIcon'

import type { CollectionData } from '../../types'

import styles from './CollectionChip.module.css'

interface CollectionChipProps {
  collection: CollectionData
}

export function CollectionChip({
  collection,
}: CollectionChipProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className={styles.collectionWrapper}>
      <Button
        variant="secondary"
        className={styles.button}
        size="small"
        as={NavLink}
        to={`/create/feeds/collections/${collection.id}`}
      >
        <FolderIcon size="xsmall" className={styles.closeFolder} />
        <FolderOpenIcon size="xsmall" className={styles.openFolder} />
        {collection.name}
      </Button>
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <Popover.Trigger>
          <IconButton
            variant="secondary"
            className={styles.chevronTrigger}
            label={isOpen ? 'Close feeds' : 'Show feeds'}
            size="small"
          >
            {isOpen ? (
              <ChevronUpIcon size="small" />
            ) : (
              <ChevronDownIcon size="small" />
            )}
          </IconButton>
        </Popover.Trigger>
        <Popover.Content
          className={styles.feedsPopover}
          align="end"
          sideOffset={4}
        >
          <Flex direction="column" gap="2xs">
            {collection.feeds.length > 0 ? (
              collection.feeds.map((feed) => (
                <Button
                  key={feed.id}
                  as={NavLink}
                  variant="tertiary"
                  to={`/create/feeds/${feed.id}`}
                  className={styles.popoverFeedButton}
                  onClick={(): void => setIsOpen(false)}
                >
                  <FeedItemIcon feedName={feed.name} url={feed.url} />
                  {feed.name}
                </Button>
              ))
            ) : (
              <Text size="sm" color="subtle" className={styles.emptyCollection}>
                No feeds in this collection
              </Text>
            )}
          </Flex>
        </Popover.Content>
      </Popover>
    </div>
  )
}
